import Vuex from "vuex";
import Vue from "vue";
import store from "@/store/store";
import { Toast } from 'mint-ui';
import router from "../../../router";
import {
    getUserIndex,
    getProectList,
    getTeam,
    getTableHeader,
    getTableBtn,
    getDetailsData,
} from '@/js/house/index'
import {
    getUserAppIndex,getAppProectList
} from '@/js/house/appindex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // 用户交付数据
        userInfor: {},          // 用户信息
        popupState: false,      //是否显示过弹框
        usreHouserList: null,   // 用户交付 首页数据
        usreAppHouserList: null,   // 用户交付 首页数据 -- app端

        userProList: null,      // 用户我的项目列表
        userAppProList: null,   // 用户我的项目列表
        userTeamObj: null,      // 项目团队

        // 能力评分数据
        scoreHeader: null,      //
        scoreTable: null,       // 表格数据

        // 能力评分详情数据
        scoreDeails: null,      // 能力详情
    },
    actions: {
        // 用户交付
        getAppHouser(cxt, data = {}) {  // 用户交付在线首页-----app端
            return new Promise((resolve, reject) => {
                getUserAppIndex(data).then(res => {
                    cxt.commit('appHouseList', res.data.data.result)
                    resolve();
                }).catch(err=>{
                    // Toast({
                    //     message: err.data.msg,
                    //     duration: 1200
                    // });
                    reject(err)
                    store.commit("loadSkeleton", {bool: false});
                });
            })
        },
        async getHouser(cxt, data = {}) {  // 用户交付在线首页
            await getUserIndex(data).then(res => {
                cxt.commit('houseList', res.data.data.result)
            });
        },
        async getProecj(cxt, data = {}) { // 用户我的项目列表
            await getProectList(data).then(res => {
                cxt.commit('ProecjList', res.data.data.result)
            })
        },
        async getAppProecj(cxt, data = {}) { // 用户我的项目列表
            await getAppProectList(data).then(res => {
                cxt.commit('appProecjList', res.data.data.result)
            })
        },
        async getTeamData(cxt, data = {}) { // 用户我的项目列表
            await getTeam(data).then(res => {
                cxt.commit('setTeam', res.data.data.result)
            })
        },

        // 能力评分
        async getTableHeadr(cxt, data = {}) { // 用户我的项目列表
            await getTableHeader(data).then(res => {
                cxt.commit('setTableHeadr', res.data.data.result)
            })
        },
        async getTableBttom(cxt, data = {}) { // 用户我的项目列表
            await getTableBtn(data).then(res => {
                cxt.commit('setTableBtm', res.data.data.result)
            })
        },

        // 能力评分详情
        async getDetails(cxt, data = {}) { // 用户我的项目列表
            await getDetailsData(data).then(res => {
                console.log(res, '8888')
                cxt.commit('setDetails', res.data.data.result)
            })
        },
    },
    getters: {
        getPopupSate(state) {
            return state.popupState
        }
    },
    mutations: {
        setPopupState(state, payload) {
            state.popupState = payload
        },
        // 用户交付
        appHouseList(state, payload) {
            state.usreAppHouserList = payload
        },
        // 用户交付
        houseList(state, payload) {
            state.usreHouserList = payload
        },
        ProecjList(state, payload) {
            state.userProList = payload
        },
        appProecjList(state, payload) {
            state.userAppProList = payload
        },
        setUser(state, payload) {
            state.userInfor = payload
        },
        setTeam(state, payload) {
            state.userTeamObj = payload
        },

        // 能力评分
        setTableHeadr(state, payload) {
            state.scoreHeader = payload
        },
        setTableBtm(state, payload) {
            state.scoreTable = payload
        },

        // 能力评分详情
        setDetails(state, payload) {
            console.log(payload, 'scoreDeails');
            state.scoreDeails = payload
        }
    }
})
